import { render } from "./DeleteBtn.vue?vue&type=template&id=2519b913"
import script from "./DeleteBtn.vue?vue&type=script&lang=js"
export * from "./DeleteBtn.vue?vue&type=script&lang=js"

import exportComponent from "/srv/crewmaldives/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__